import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import ModelFooter from './ModelFooter'
import Separator from '../../../components/helpers/Separator'
import DuplicatedServiceOrdersList from './DuplicatedServiceOrdersList'

const DuplicatedServiceOrdersModal = props => {
  return (
    <ControlledModal width="46rem" disableClickOutside {...props}>
      <ModalHeader />

      <Separator weight={6} />
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={6} />

      <DuplicatedServiceOrdersList />

      <ModelFooter />
    </ControlledModal>
  )
}

export default DuplicatedServiceOrdersModal
